<template>
  <div>
    <transferRateForm
      :dialog="transferRateDialog"
      @setDialog="transferRateDialog = $event"
      :editedIndex="editedIndex"
      @setEditIndex="editedIndex = $event"
    />
    <v-layout row>
      <!-- <v-flex xs4></v-flex>
      <v-flex xs4>
        <v-spacer></v-spacer>
      </v-flex>-->
      <v-flex xs12>
        <v-toolbar dense flat>
          <v-text-field
            v-model="search"
            prepend-icon="search"
            label="Search"
            single-line
            hide-details
            style="padding:0;"
          ></v-text-field>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-data-table
      :search="search"
      :headers="headers"
      :loading="loading_message"
      :items="start_transfer_list"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ start_transfer_list.indexOf(props.item)+1 }}</td>
        <td class="text-xs-center">{{ props.item.transport_sub_district_start_name }}</td>
        <td class="justify-center layout px-0">
          <v-btn @click="select(props.item)">setting</v-btn>
        </td>
      </template>

      <template slot="no-data">
        <div class="text-xs-center" v-if="loading_message == false">No data available</div>
        <div class="text-xs-center" v-else>
          <v-progress-circular :size="30" color="primary" indeterminate></v-progress-circular>Loading data ...
        </div>
      </template>
    </v-data-table>

    <!-- <div class="text-xs-center py-2">
      <v-pagination circle v-model="pagination.page" :length="pages"></v-pagination>
    </div>-->
  </div>
</template>

<script>
import transferRateForm from "./TransferRateForm";
import { mapState } from "vuex";
export default {
  data: () => ({
    search: "",
    loading_message: false,
    transferRateDialog: false,
    dialog: false,
    editedIndex: -1,
    pagination: {
      rowsPerPage: 10
    },
    headers: [
      {
        text: "#",
        align: "center",
        sortable: false,
        value: "name"
      },
      {
        text: "Start point",
        align: "center",
        value: "transport_sub_district_start_name",
        sortable: false
      },
      {
        text: "Action",
        align: "center",
        value: "name",
        sortable: false
      }
    ]
  }),
  components: {
    transferRateForm
  },
  computed: {
    ...mapState({
      start_transfer_list: state => state.fetchFoodRateBack.start_transfer_list
    }),
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  created() {
    this.fetchData();
  },
  methods: {
    select(item) {
      this.$store.commit("fetchFoodRateBack/getEndTransferList");
      this.$store.commit("fetchFoodRateBack/getSelectedTransfer", item);
      this.$store.dispatch(
        "fetchFoodRateBack/getTransferRateList",
        item.transport_sub_district_start_id
      );
      this.$emit("selectComponantes", "startEndTransferList");
    },
    initialize() {
      this.users = [
        {
          num: "1",
          start_point: "ราไวย์",
          action: ""
        },
        {
          num: "2",
          start_point: "ตลาดเหนือ",
          action: ""
        }
      ];
    },
    async fetchData() {
      this.loading_message = true;
      await this.$store.dispatch("fetchFoodRateBack/getStartTransferList");
      this.loading_message = false;
    }
  }
};
</script>

